<template>
  <ul class="services">
    <li
      v-for="(service, i) in data_services[this.lang]"
      :key="`service_${i}`"
      v-scroll-reveal="{ delay: i * 100 }"
    >
      <span class="highlight">{{ service.title }}</span>
      <span>{{ service.description }}</span>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Services',
  props: {
    lang: { type: String, default: 'EN' }
  },
  data() {
    return {
      data_services: {
        EN: [
          {
            title: 'Go-to-market strategy',
            description: 'The plan to bring your big idea to market'
          },
          {
            title: 'Online store creation',
            description: 'Build and launch your ecommerce empire'
          },
          {
            title: 'Sales funnel optimization',
            description: 'Streamlining customer journeys to boost conversion'
          },
          {
            title: 'Customer insights and analysis',
            description: 'Segmenting users so you can serve them better'
          },
          {
            title: 'Engagement operations',
            description: 'Implementing scalable systems to cultivate communities'
          }
        ],
        ES: [
          {
            title: 'Estrategia de salida al mercado',
            description: 'El plan para llevar tu gran idea al mercado'
          },
          {
            title: 'Creación de la tienda online',
            description: 'Construir y lanzar tu imperio de comercio electrónico'
          },
          {
            title: 'Optimización del proceso de ventas',
            description: 'Optimizar la experiencia de los clientes para impulsar la conversión'
          },
          {
            title: 'Análisis e información de los clientes',
            description: 'Segmentar a los usuarios para poder servirles mejor'
          },
          {
            title: 'Operaciones de compromiso',
            description: 'Aplicar sistemas escalables para cultivar comunidades'
          }
        ]
      }
    }
  }
}
</script>

<style scoped>
  .services {
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 80px;
    grid-row-gap: 40px;
    padding: 80px 0;
    max-width: 900px;
  }

  span {
    display: block;
  }

  @media (max-width: 768px) {
    .services {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 500px) {
    .services {
      padding: 20px 40px 20px 20px;
    }
  }

  @media (max-width: 320px) {
    .services {
      padding: 20px 30px 20px 10px;
    }
  }
</style>
